import React from 'react';

function Excavator(){
    return(
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" id="icon" x="0px" y="0px" viewBox="0 0 124.6 122">
<g id="excavator">
	<path className="st3" d="M54.9,86.4H12.7c0,0-13.1,4-9.3,17.5c0,0,3.5,10.5,13.3,9.9h46.1c0,0,10.4-3.5,11.1-13.8c0,0-1.2-7.4-8.5-13.7
		c0,0-0.1-4.7-0.5-11.1c-0.6-9.4-2-22.4-4.8-30.5c0,0-1.5-2-4.2-2.2H36.6c0,0-5.9,1.6-4.1,14.1"/>
	<path className="st3" d="M64.9,75.1H49.6c0,0-5.4-7.9-9.2-8.2H11.9c0,0-1.6,0.5-1.2,7.9"/>
	<path className="st4" d="M16.5,102.3h-1.3c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h1.3c1,0,1.8,0.8,1.8,1.8v1.3
		C18.3,101.5,17.5,102.3,16.5,102.3z"/>
	<path className="st4" d="M27.8,102.3h-1.3c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h1.3c1,0,1.8,0.8,1.8,1.8v1.3
		C29.6,101.5,28.8,102.3,27.8,102.3z"/>
	<path className="st4" d="M38.7,102.3h-1.3c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h1.3c1,0,1.8,0.8,1.8,1.8v1.3
		C40.5,101.5,39.7,102.3,38.7,102.3z"/>
	<path className="st4" d="M50.3,102.2H49c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h1.3c1,0,1.8,0.8,1.8,1.8v1.3
		C52.2,101.4,51.3,102.2,50.3,102.2z"/>
	<path className="st4" d="M60.9,102.2h-1.3c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h1.3c1,0,1.8,0.8,1.8,1.8v1.3
		C62.7,101.4,61.9,102.2,60.9,102.2z"/>
	<path className="st3" d="M89,9.5h10.5h2.4h3.7c0,0,1.3,0.3,1.3,5.4v47.3"/>
	<line className="st3" x1="99.5" y1="9.5" x2="60.5" y2="34.3"/>
	<line className="st3" x1="101.9" y1="9.5" x2="72.5" y2="61.4"/>
	<circle className="st5" cx="106.1" cy="76.1" r="15.6"/>
	<circle className="st6" cx="106.3" cy="76.2" r="13"/>
</g>
</svg>

    )
}

export default Excavator;